<template>
  <div class="max-w-7xl mx-auto py-2 md:py-6 sm:px-6 lg:px-4 grid grid-cols-2 gap-4">
    <section class="p-4 col-span-2">
      <brandname-component></brandname-component>
    </section>
    <!-- Logo y favicon en dos columnas solo desde 2xl: por debajo, cada una quedaría demasiado estrecha. -->
    <section class="p-4 mt-6 col-span-2 2xl:col-span-1">
      <logo-branding-component></logo-branding-component>
    </section>
    <section class="p-4 mt-6 col-span-2 2xl:col-span-1">
      <favicon-component></favicon-component>
    </section>
    <help-center-component :url="this.helpCenter.kn_branding_url" class="pl-3"></help-center-component>
  </div>
</template>

<script>
import BrandnameComponent from "@/views/customization/identity/BrandnameComponent";
import LogoBrandingComponent from "@/views/customization/branding/LogoBrandingComponent";
import FaviconComponent from "@/views/customization/branding/FaviconComponent";
import HelpCenterComponent from "@/views/common/HelpCenterComponent";
import helpcenter from "@/services/helpcenter/links";

/* Personalización › Identidad: nombre, eslogan, logo y favicon. */
export default {
  name: "IdentityComponent",
  components: {
    BrandnameComponent,
    LogoBrandingComponent,
    FaviconComponent,
    HelpCenterComponent,
  },
  setup() {
    return {
      helpCenter: helpcenter,
    }
  },
}
</script>
